export const averageSearchResults = {
  analysisType: 'average',
  eventCollection: 'kb.search.view',
  key: 'averageSearchResults',
  targetProperty: 'search.result_count',
}
